<script>
export default {
    name: "AdmissionNote",

    props: {
        showModal: Boolean,
        patient: Object,
    },

    methods: {

        printAdmissionNoteReport() {
            let queryString = `?AdmissionID=${this.patient.id}`;
            window.open(
                `/morgue/admission-note${queryString}`, 
                '_blank', `AdmissionNotePrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Admission Note</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <!-- <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">Patient: 
                    <span class="text-blue-700">{{ patient.patient }}</span></h5>
            </div>
            <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">IP File No: 
                    <span class="text-blue-700">{{ patient.ipfileno || `-` }}</span></h5>
            </div>
            <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">OP File No: 
                    <span class="text-blue-700">{{ patient.opfileno || `-` }}</span></h5>
            </div>
            <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">Admitted on: 
                    <span class="text-blue-700">{{ patient.date | dateFormat }}</span></h5>
            </div>
            <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">Morgue No: 
                    <span class="text-blue-700">{{ patient.morgueNo }}</span></h5>
            </div>
            <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">Brought By: 
                    <span class="text-blue-700">{{ patient.broughtBy || `-` }}</span></h5>
            </div>
            <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">Village: 
                    <span class="text-blue-700">{{ patient.village || `-` }}</span></h5>
            </div>
            <div class="md:w-1/2 w-full p-1">
                <h5 class="text-base font-medium">Admitted By: 
                    <span class="text-blue-700">{{ patient.admittedBy }}</span></h5> 
            </div> -->

            <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Name: <span class="text-blue-700">{{ patient.patient}}</span></h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">MRN:<span class="text-blue-700">{{ patient.patienT_ID }}</span> </h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Morque No: <span class="text-blue-700">{{ patient.morgueNo|'-' }}</span></h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">National Id:<span class="text-blue-700">{{ patient.nationalid|'-' }}</span> </h5>
            </div>
             
        </div> 
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:flex-1 my-1">
                <h5 class="font-semibold text-sm">Date Admitted: <span class="text-blue-700">{{ patient.date | dateFormat }}</span></h5> 
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Package:<span class="text-blue-700">{{ patient.package|'-' }}</span> </h5>
            </div>
             <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Bed: <span class="text-blue-700">{{ patient.bed }}</span></h5>
            </div>
            
             
        </div>
         
         <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Brought By:<span class="text-blue-700">{{ patient.broughtBy|'-'}}</span> </h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Brought By Relationship:<span class="text-blue-700">{{ patient.broughtByRelationship|'-' }}</span> </h5>
            </div> <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Brought By ID:<span class="text-blue-700">{{ patient.broughtByIdNo|'-' }}</span> </h5>
            </div>
            
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/4 w-1/2">
                <h5 class="font-semibold text-sm">Brought By Tel No:<span class="text-blue-700">{{ patient.broughtByTelNo|'-' }}</span> </h5>
            </div> <div class="md:w-1/4 w-1/2">
                <h5 class="font-semibold text-sm">Place of Death:<span class="text-blue-700">{{ patient.placeOfDeath|'-' }}</span> </h5>
            </div>
            
            <div class="md:w-1/4 w-1/2">
                <h5 class="font-semibold text-sm">Admitted By:<span class="text-blue-700">{{ patient.admittedBy|'-' }}</span> </h5>
            </div><div class="md:w-1/4 w-1/2">
                <h5 class="font-semibold text-sm">User:<span class="text-blue-700">{{ patient.userName|'-' }}</span> </h5>
            </div>
            <!-- <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Subcounty:<span class="text-blue-700">{{ patient.subcounty|'-'}}</span> </h5>
            </div> -->
            
        </div>
        
       
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button
            @click.prevent="printAdmissionNoteReport"
            class="btn-info btn-sm text-xs rounded">
                <i class="fa fa-print"></i> Print</button>
      </template>
    </tail-modal>
</template>